import React from "react";

const ProductCard = ({ icon, category, title, description, link }) => (
  <a href={link}>
  <div className="productCard">
    <img loading="lazy" src={icon} alt="" className="productIcon" />
    <div className="productInfo">
      <span className="productCategory">{category}</span>
      <h3 className="productTitle">{title}</h3>
      <p className="productDescription">{description}</p>
    </div>
  </div>
  </a>
);

const ProductCards = () => {
  const products = [
    {
      icon: "/icons/icon-security.svg",
      category: "Security",
      title: "Sysdig Secure",
      description: "CNAPP Powered by Runtime Insights",
      link: "/en/docs/sysdig-secure/"
    },
    {
      icon: "/icons/icon-monitor.svg",
      category: "Observability",
      title: "Sysdig Monitor",
      description: "Kubernetes and Prometheus Monitoring",
      link: "/en/docs/sysdig-monitor/"
    },
  ];

  return (
    <section className="productCards">
      {products.map((product, index) => (
        <ProductCard key={index} {...product} />
      ))}
    </section>
  );
};

export default ProductCards;
